import React from "react";
import Navbar from "../components/sub-comp/Navbar.jsx";
import Footer from "../components/sub-comp/MainFooter.jsx";
import FloatingSocialPanels from "../components/sub-comp/FloatingSocialPanels";
import { FaTrophy, FaMedal, FaUsers, FaCalendarAlt, FaMapMarkerAlt, FaPhone, FaEnvelope, FaFacebook, FaTwitter, FaInstagram } from "react-icons/fa";

const Athletics = () => {
  const sportsPrograms = [
    {
      id: 1,
      name: "Football",
      description: "Our premier football program competes at the highest level with dedicated coaching and state-of-the-art facilities.",
      image: "https://images.unsplash.com/photo-1431324155629-1a6deb1dec8d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80",
      season: "August - May",
      coach: "Coach Michael Johnson",
      achievements: ["Regional Champions 2023", "Best Defense Award 2023"]
    },
    {
      id: 2,
      name: "Basketball",
      description: "Fast-paced basketball program focusing on skill development, teamwork, and competitive excellence.",
      image: "https://images.unsplash.com/photo-1546519638-68e109fcdc9d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80",
      season: "October - March",
      coach: "Coach Sarah Williams",
      achievements: ["Conference Finalists 2023", "Most Improved Team 2023"]
    },
    {
      id: 3,
      name: "Volleyball",
      description: "Dynamic volleyball program emphasizing technique, strategy, and team coordination.",
      image: "https://images.unsplash.com/photo-1612872087724-bb876b2e67d1?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80",
      season: "September - April",
      coach: "Coach David Chen",
      achievements: ["State Semifinalists 2023", "Academic Excellence Award"]
    },
    {
      id: 4,
      name: "Track & Field",
      description: "Comprehensive track and field program covering sprints, distance, field events, and relays.",
      image: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80",
      season: "March - June",
      coach: "Coach Lisa Rodriguez",
      achievements: ["5 State Records", "Team Championship 2023"]
    },
    {
      id: 5,
      name: "Tennis",
      description: "Elite tennis program with individual and doubles competition, focusing on technique and mental toughness.",
      image: "https://images.unsplash.com/photo-1551698618-1dfe5d97d256?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80",
      season: "February - May",
      coach: "Coach Robert Kim",
      achievements: ["Individual State Champion 2023", "Team Runner-up 2023"]
    },
    {
      id: 6,
      name: "Swimming",
      description: "Competitive swimming program with year-round training and multiple stroke specialization.",
      image: "https://images.unsplash.com/photo-1530549387789-4c1017266635?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80",
      season: "Year Round",
      coach: "Coach Maria Garcia",
      achievements: ["Regional Champions 2023", "3 National Qualifiers"]
    }
  ];

  const recentNews = [
    {
      id: 1,
      title: "Football Team Advances to Regional Finals",
      excerpt: "Our football team secured a spot in the regional finals after a thrilling victory against State University.",
      date: "2024-01-15",
      image: "https://images.unsplash.com/photo-1431324155629-1a6deb1dec8d?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80",
      category: "Football"
    },
    {
      id: 2,
      title: "Track & Field Athletes Set New Records",
      excerpt: "Three new school records were set at the recent track and field championship meet.",
      date: "2024-01-10",
      image: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80",
      category: "Track & Field"
    },
    {
      id: 3,
      title: "Basketball Team Hosts Annual Tournament",
      excerpt: "Join us for the annual basketball tournament featuring teams from across the region.",
      date: "2024-01-05",
      image: "https://images.unsplash.com/photo-1546519638-68e109fcdc9d?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80",
      category: "Basketball"
    }
  ];

  const upcomingEvents = [
    {
      id: 1,
      title: "Football vs. City College",
      date: "2024-02-15",
      time: "7:00 PM",
      location: "Home Stadium",
      sport: "Football"
    },
    {
      id: 2,
      title: "Basketball Championship",
      date: "2024-02-20",
      time: "6:30 PM",
      location: "Sports Complex",
      sport: "Basketball"
    },
    {
      id: 3,
      title: "Track & Field Meet",
      date: "2024-02-25",
      time: "9:00 AM",
      location: "Track Stadium",
      sport: "Track & Field"
    }
  ];

  return (
    <div>
      <Navbar />
      
      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-custom-pink via-purple-900 to-indigo-900 text-white py-20 lg:py-32">
        <div className="absolute inset-0 bg-black/30"></div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold mb-6">
            JR Institute Athletics
          </h1>
          <p className="text-xl sm:text-2xl mb-8 max-w-3xl mx-auto">
            Excellence in Sports, Character, and Academic Achievement
          </p>
          <div className="flex flex-wrap justify-center gap-8 text-center">
            <div className="flex items-center gap-2">
              <FaTrophy className="text-gold text-2xl" />
              <span className="text-lg font-semibold">15+ Sports Programs</span>
            </div>
            <div className="flex items-center gap-2">
              <FaMedal className="text-gold text-2xl" />
              <span className="text-lg font-semibold">50+ Championships</span>
            </div>
            <div className="flex items-center gap-2">
              <FaUsers className="text-gold text-2xl" />
              <span className="text-lg font-semibold">300+ Student Athletes</span>
            </div>
          </div>
        </div>
      </section>

      {/* Sports Programs Overview */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl sm:text-4xl font-bold text-custom-pink mb-4">
              Our Sports Programs
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              Discover our comprehensive athletic programs designed to develop both physical excellence and character.
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {sportsPrograms.map((sport) => (
              <div key={sport.id} className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300">
                <div className="relative h-48 overflow-hidden">
                  <img
                    src={sport.image}
                    alt={sport.name}
                    className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                  <div className="absolute bottom-4 left-4">
                    <span className="bg-custom-pink text-white px-3 py-1 rounded-full text-sm font-semibold">
                      {sport.name}
                    </span>
                  </div>
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-bold text-gray-900 mb-2">{sport.name}</h3>
                  <p className="text-gray-600 mb-4">{sport.description}</p>
                  <div className="space-y-2 text-sm text-gray-500">
                    <div className="flex items-center gap-2">
                      <FaCalendarAlt className="text-gold" />
                      <span>Season: {sport.season}</span>
                    </div>
                    <div className="flex items-center gap-2">
                      <FaUsers className="text-gold" />
                      <span>Coach: {sport.coach}</span>
                    </div>
                  </div>
                  <div className="mt-4">
                    <h4 className="font-semibold text-gray-900 mb-2">Recent Achievements:</h4>
                    <ul className="space-y-1">
                      {sport.achievements.map((achievement, index) => (
                        <li key={index} className="text-sm text-gray-600 flex items-center gap-2">
                          <FaMedal className="text-gold text-xs" />
                          {achievement}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Recent News & Updates */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl sm:text-4xl font-bold text-custom-pink mb-4">
              Latest Athletics News
            </h2>
            <p className="text-lg text-gray-600">
              Stay updated with the latest news and achievements from our athletic programs.
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {recentNews.map((news) => (
              <article key={news.id} className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300">
                <div className="relative h-48 overflow-hidden">
                  <img
                    src={news.image}
                    alt={news.title}
                    className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
                  />
                  <div className="absolute top-4 left-4">
                    <span className="bg-gold text-white px-3 py-1 rounded-full text-sm font-semibold">
                      {news.category}
                    </span>
                  </div>
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-bold text-gray-900 mb-2 hover:text-custom-pink transition-colors">
                    {news.title}
                  </h3>
                  <p className="text-gray-600 mb-4">{news.excerpt}</p>
                  <div className="flex items-center justify-between">
                    <span className="text-sm text-gray-500">{news.date}</span>
                    <a href="#" className="text-custom-pink hover:text-gold font-semibold">
                      Read More →
                    </a>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* Upcoming Events */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl sm:text-4xl font-bold text-custom-pink mb-4">
              Upcoming Events
            </h2>
            <p className="text-lg text-gray-600">
              Don't miss our upcoming games and athletic events.
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {upcomingEvents.map((event) => (
              <div key={event.id} className="bg-white rounded-xl shadow-lg p-6 hover:shadow-xl transition-shadow duration-300">
                <div className="flex items-center gap-3 mb-4">
                  <div className="bg-custom-pink text-white p-3 rounded-full">
                    <FaCalendarAlt className="text-xl" />
                  </div>
                  <div>
                    <h3 className="text-lg font-bold text-gray-900">{event.title}</h3>
                    <span className="text-sm text-gold font-semibold">{event.sport}</span>
                  </div>
                </div>
                <div className="space-y-2 text-sm text-gray-600">
                  <div className="flex items-center gap-2">
                    <FaCalendarAlt className="text-gold" />
                    <span>{event.date}</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <span className="text-gold">⏰</span>
                    <span>{event.time}</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <FaMapMarkerAlt className="text-gold" />
                    <span>{event.location}</span>
                  </div>
                </div>
                <button className="w-full mt-4 bg-gold text-white py-2 px-4 rounded-lg hover:bg-custom-pink transition-colors duration-300">
                  Get Tickets
                </button>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Facilities & Contact */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-12">
            {/* Facilities */}
            <div>
              <h2 className="text-3xl sm:text-4xl font-bold text-custom-pink mb-6">
                Athletic Facilities
              </h2>
              <div className="space-y-6">
                <div className="flex items-start gap-4">
                  <div className="bg-gold text-white p-3 rounded-full">
                    <FaTrophy className="text-xl" />
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-gray-900 mb-2">Main Stadium</h3>
                    <p className="text-gray-600">State-of-the-art football stadium with seating for 5,000 spectators and modern lighting system.</p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <div className="bg-gold text-white p-3 rounded-full">
                    <FaUsers className="text-xl" />
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-gray-900 mb-2">Sports Complex</h3>
                    <p className="text-gray-600">Multi-purpose facility housing basketball courts, volleyball courts, and fitness center.</p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <div className="bg-gold text-white p-3 rounded-full">
                    <FaMedal className="text-xl" />
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-gray-900 mb-2">Track & Field Stadium</h3>
                    <p className="text-gray-600">Olympic-standard track with field event areas and modern timing systems.</p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <div className="bg-gold text-white p-3 rounded-full">
                    <span className="text-xl">🏊</span>
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-gray-900 mb-2">Swimming Pool</h3>
                    <p className="text-gray-600">Competition-sized swimming pool with starting blocks and timing systems.</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Contact Information */}
            <div>
              <h2 className="text-3xl sm:text-4xl font-bold text-custom-pink mb-6">
                Contact Athletics
              </h2>
              <div className="space-y-6">
                <div className="flex items-center gap-4">
                  <div className="bg-custom-pink text-white p-3 rounded-full">
                    <FaPhone className="text-xl" />
                  </div>
                  <div>
                    <h3 className="text-lg font-bold text-gray-900">Phone</h3>
                    <p className="text-gray-600">+255 22 123 4567</p>
                  </div>
                </div>
                <div className="flex items-center gap-4">
                  <div className="bg-custom-pink text-white p-3 rounded-full">
                    <FaEnvelope className="text-xl" />
                  </div>
                  <div>
                    <h3 className="text-lg font-bold text-gray-900">Email</h3>
                    <p className="text-gray-600">athletics@jriit.ac.tz</p>
                  </div>
                </div>
                <div className="flex items-center gap-4">
                  <div className="bg-custom-pink text-white p-3 rounded-full">
                    <FaMapMarkerAlt className="text-xl" />
                  </div>
                  <div>
                    <h3 className="text-lg font-bold text-gray-900">Address</h3>
                    <p className="text-gray-600">JR Institute of Information Technology<br />Athletics Department<br />Dar es Salaam, Tanzania</p>
                  </div>
                </div>
              </div>

              {/* Social Media */}
              <div className="mt-8">
                <h3 className="text-xl font-bold text-gray-900 mb-4">Follow Us</h3>
                <div className="flex gap-4">
                  <a href="#" className="bg-custom-pink text-white p-3 rounded-full hover:bg-gold transition-colors duration-300">
                    <FaFacebook className="text-xl" />
                  </a>
                  <a href="#" className="bg-custom-pink text-white p-3 rounded-full hover:bg-gold transition-colors duration-300">
                    <FaTwitter className="text-xl" />
                  </a>
                  <a href="#" className="bg-custom-pink text-white p-3 rounded-full hover:bg-gold transition-colors duration-300">
                    <FaInstagram className="text-xl" />
                  </a>
                </div>
              </div>

              {/* Quick Links */}
              <div className="mt-8">
                <h3 className="text-xl font-bold text-gray-900 mb-4">Quick Links</h3>
                <div className="space-y-2">
                  <a href="#" className="block text-custom-pink hover:text-gold transition-colors duration-300">
                    → Athletic Schedules
                  </a>
                  <a href="#" className="block text-custom-pink hover:text-gold transition-colors duration-300">
                    → Team Rosters
                  </a>
                  <a href="#" className="block text-custom-pink hover:text-gold transition-colors duration-300">
                    → Athletic Policies
                  </a>
                  <a href="#" className="block text-custom-pink hover:text-gold transition-colors duration-300">
                    → Tryout Information
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
      <FloatingSocialPanels />
    </div>
  );
};

export default Athletics;








